
import BarcodeLabelList from '@/components/BarcodeLabelList.vue'
import BarcodeSymbologiesSelection from '@/components/BarcodeSymbologiesSelection.vue'
import MultipleBarcodeScanMixin from '@/components/mixins/MultipleBarcodeScanMixin.vue'
import ScanArea from '@/components/svg/ScanArea.vue'
import { RECYCLE_MULTIPLE_BARCODE, SAVE_SCANNED_BARCODES } from '@/store/actions'
import { recycleMultipleBarcode } from '@/utils/api'
import { IBarcode, IBarcodeDefinitionType, IProject } from 'smartbarcode-web-core/src/utils/types/index'
import { Options, mixins } from 'vue-class-component'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import SelectionCameraPopup from '@/components/dialog/SelectionCameraPopup.vue'
import IconSwitch from '@/components/svg/IconSwitch.vue'
@Options({
  components: {
    ScanArea,
    BarcodeLabelList,
    BarcodeSymbologiesSelection,
    IconSwitch,
    SelectionCameraPopup,
  },
  name: 'BulkRecycle',
})
export default class BulkRecycle extends mixins(MultipleBarcodeScanMixin) {
  loading = false
  dialogVisible = false
  checkScannedBarcode = false
  extParams = {} as Record<string, unknown>
  isReadyToScan = true
  messageThrow = ''

  async beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    await this.onLeaveGuard(to, from, next)
  }

  created() {
    this.isForcedHideMultipleScan = true
  }

  onCheckScannedBarcode() {
    this.checkScannedBarcode = true
    this.dialogVisible = true
  }

  onCloseDialog() {
    this.dialogVisible = false
    this.checkScannedBarcode = false
  }

  barcodeTypeInfo(barcodeType: string): IBarcodeDefinitionType {
    return this.$store.state.project?.details?.barcodeTypes[barcodeType]
  }

  get barcode(): IBarcode {
    return this.$store.state.barcode?.barcode
  }

  get currentTrackPointKey() {
    return this.barcode?.currentTrackPointKey
  }

  isCurrentRecycleableTrackpoint(barcode: IBarcode): boolean {
    return (this.barcodeTypeInfo(barcode.barcodeType)?.barcodeRecyclableTrackPoints ?? []).includes(
      this.currentTrackPointKey
    )
  }

  isAllowRecycle(barcode: IBarcode): { message: string } {
    const error = { message: '' }
    if (!this.isCurrentRecycleableTrackpoint(barcode)) {
      error.message = 'cant_recycle_at_this_trackpoint'
    }

    if (this.childrenCount > 0) {
      if (!this.project.isRecycleChildren || this.hasParent(barcode)) {
        error.message = 'errors.3025'
      }
    }

    if (this.parentBarcodeId === barcode?.id) {
      error.message = 'barcode_pairing_by_itself_error'
    }

    if (!barcode?.barcodeType) {
      error.message = 'barcode not activated'
    }
    return error
  }

  get project(): IProject {
    return this.$store.state.project.details
  }

  hasParent(barcode: IBarcode): boolean {
    return barcode?.hasParent
  }

  get childrenCount() {
    return this.barcode?.childrenCount || 0
  }

  async validateBarcode(resultScanned: IBarcode) {
    const error = this.isAllowRecycle(resultScanned)
    if (error.message) {
      throw this.$t(error.message)
    }
    const data = {
      barcodeIds: [resultScanned?.id],
      isDryRun: true,
    }
    try {
      await recycleMultipleBarcode(data)
    } catch (error) {}
  }

  get parentBarcodeId() {
    return this.$store.state.barcode?.barcode?.id || ''
  }

  forward() {
    if (!this.barcodes || this.barcodes.length === 0) {
      return
    }
    const listBarcodeIds = [this.$route.params.barcodeId, ...this.barcodes.map((barcode: IBarcode) => barcode.id)]
    this.$store.dispatch(SAVE_SCANNED_BARCODES, [...this.barcodes])
    this.$router.push({
      name: 'scanned-barcode-list',
      params: {
        title: this.$t('recycle_read_result'),
        operation: RECYCLE_MULTIPLE_BARCODE,
        extParams: JSON.stringify(listBarcodeIds),
      },
    })
  }
}
